import { Charts } from './Charts';
import PeopleWithDisabilitiesChartsDataProvider from './contexts/PeopleWithDisabilitiesChartsDataContext';

const PeopleWithDisabilitiesWrapper = () => {
    return (
        <PeopleWithDisabilitiesChartsDataProvider>
            <Charts />
        </PeopleWithDisabilitiesChartsDataProvider>
    );
};

export default PeopleWithDisabilitiesWrapper;
